import { TDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';

interface INeedConsultationProps {
  device: TDeviceType;
}

export const NeedConsultation: React.FC<INeedConsultationProps> = ({ device }) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Нужна консультация?</div>
      <div className={style['descr']}>
        Позвоните нам{' '}
        <a className={style['phonenumber']} href="tel:88003017927">
          8 (800) 301-79-27
        </a>
      </div>
      <div className={style['descr']}>или обратитесь к вашему персональному менеджеру</div>
      <div className={style['lines']} />
    </div>
  );
};
